import React from "react";
import { Tooltip } from "@mui/material";
import Zoom from "@mui/material/Zoom";
import { TooltipProps } from "@mui/material";

export default function TaxGuruTooltip({ children, childrenNoWrap, ...other }: TooltipProps & { childrenNoWrap?: boolean }) {
    if (childrenNoWrap) {
        return (
            <Tooltip {...other} arrow TransitionComponent={Zoom}>
                {children}
            </Tooltip>
        );
    }
    return (
        <Tooltip {...other} arrow TransitionComponent={Zoom}>
            <span>{children}</span>
        </Tooltip>
    );
}
